import { render, staticRenderFns } from "./StartMovingModal.vue?vue&type=template&id=64ee385b&scoped=true&"
import script from "./StartMovingModal.vue?vue&type=script&lang=ts&"
export * from "./StartMovingModal.vue?vue&type=script&lang=ts&"
import style0 from "./StartMovingModal.vue?vue&type=style&index=0&id=64ee385b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee385b",
  null
  
)

export default component.exports